import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AgendaDetailsPage } from './agenda-details.page';
import { TranslateModule } from '@ngx-translate/core';
import { PipeSharedModule } from '@pipes/pipe-shared.module';

const routes: Routes = [
  {
    path: '',
    component: AgendaDetailsPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    TranslateModule,
    PipeSharedModule
  ],
  declarations: [AgendaDetailsPage]
})
export class AgendaDetailsPageModule {}
